import { render, staticRenderFns } from "./VueltaCamionTarifa.vue?vue&type=template&id=37e9a664&"
import script from "./VueltaCamionTarifa.vue?vue&type=script&lang=js&"
export * from "./VueltaCamionTarifa.vue?vue&type=script&lang=js&"
import style0 from "./VueltaCamionTarifa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports